import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import AvoirList from '../components/avoir/AvoirList';
import AvoirForm from '../components/avoir/AvoirForm';
import SingleAvoir from '../components/avoir/SingleAvoir';
import AvoirDeleteButton from '../components/avoir/AvoirDeleteButton';
import AvoirUpdateForm from '../components/avoir/AvoirupdateForm';
import ItemsInAvoirList from '../components/avoir/ItemInAvoirList';
import AddItemToAvoirForm from '../components/avoir/AddItemToAvoirForm';
import UpdateItemInAvoirForm from '../components/avoir/updateItemInAvoirForm';
import DeleteItemFromAvoirButton from '../components/avoir/DeleteItemFromAvoirButton';
import DemarqueList from '../components/avoir/DemarqueList';
import SingleDemarque from '../components/avoir/SingleDemarque';
import CorrectionStockList from '../components/avoir/CorrectionStockList';
import SingleCorrectionStock from '../components/avoir/SingleCorrectionStock';

const AvoirManagementPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState('list');
  const [selectedAvoirId, setSelectedAvoirId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedDemarqueRef, setSelectedDemarqueRef] = useState(null);
  const [selectedCorrectionRef, setSelectedCorrectionRef] = useState(null);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const view = params.get('view');
    if (view === 'demarque') {
      setCurrentView('demarqueList');
    } else if (view === 'correctionstock') {
      setCurrentView('correctionStockList');
    }
  }, [location.search]);


  
  const handleSelectAvoir = (id) => {
    if (id === 'demarque') {
      setCurrentView('demarqueList');
      setSelectedDemarqueRef(null);
      return;
    }
    setSelectedAvoirId(id);
    setCurrentView('viewAvoir');
  };

  const handleViewItemInAvoir = (itemId) => {
    setSelectedItemId(itemId);
    setCurrentView('viewItemInAvoir');
  };

  const handleSelectDemarque = (ref) => {
    setSelectedDemarqueRef(ref);
    setCurrentView('demarqueSingle');
  };

  const backToDemarqueList = () => {
    setCurrentView('demarqueList');
    setSelectedDemarqueRef(null);
  };

  const handleSelectCorrection = (ref) => {
    setSelectedCorrectionRef(ref);
    setCurrentView('correctionStockSingle');
  };

  const backToCorrectionStockList = () => {
    setCurrentView('correctionStockList');
    setSelectedCorrectionRef(null);
  };

  const backToAvoirList = () => {
    setCurrentView('list');
    setSelectedDemarqueRef(null);
    navigate('/avoir');
  };

  const backToArticleList = () => {
    navigate('/article');
  };

  return (
    <div>
      {currentView === 'create' && <AvoirForm />}
      {currentView === 'update' && <AvoirUpdateForm avoirId={selectedAvoirId} />}
      {currentView === 'delete' && <AvoirDeleteButton avoirId={selectedAvoirId} onSuccess={() => setCurrentView('list')} />}
      {currentView === 'list' && <AvoirList onSelectAvoir={handleSelectAvoir} />}
      {currentView === 'viewAvoir' && selectedAvoirId && (
        <SingleAvoir avoirId={selectedAvoirId} onSelectItem={handleViewItemInAvoir} onChangeView={setCurrentView} />
      )}
      {currentView === 'viewItemInAvoir' && selectedAvoirId && selectedItemId && (
        <>
          <UpdateItemInAvoirForm refAvoir={selectedAvoirId} codeArt={selectedItemId} />
          <DeleteItemFromAvoirButton refAvoir={selectedAvoirId} codeArt={selectedItemId} onSuccess={() => setCurrentView('viewAvoir')} />
        </>
      )}
      {currentView === 'addItem' && selectedAvoirId && (
        <AddItemToAvoirForm refAvoir={selectedAvoirId} onSuccess={() => setCurrentView('viewAvoir')} />
      )}
      {currentView === 'viewItems' && selectedAvoirId && (
        <ItemsInAvoirList refAvoir={selectedAvoirId} />
      )}
      {currentView === 'demarqueList' && (
        <DemarqueList onBack={backToArticleList} onSelectDemarque={handleSelectDemarque} />
      )}
      {currentView === 'demarqueSingle' && selectedDemarqueRef && (
        <SingleDemarque
          refDem={selectedDemarqueRef}
          onBack={backToDemarqueList}
          onDeleted={backToDemarqueList}
        />
      )}
      {currentView === 'correctionStockList' && (
        <CorrectionStockList onBack={backToArticleList} onSelectCorrection={handleSelectCorrection} />
      )}
      {currentView === 'correctionStockSingle' && selectedCorrectionRef && (
        <SingleCorrectionStock
          refCor={selectedCorrectionRef}
          onBack={backToCorrectionStockList}
          onDeleted={backToCorrectionStockList}
        />
      )}
    </div>
  );
};

export default AvoirManagementPage;
